<div *ngIf="cardInfo() as cardInfo" class="activity-card-call">
  <crm-activity-card
    [activity]="activity()"
    [icon]="ActivityIcons[ActivityTypes.Call]"
    [showPrimaryAssociation]="false"
  >
    <!-- Activity title -->
    <span activity-title>
      <div>
        <strong>{{ 'ACTIVITY.CALL.TITLE' | translate }}</strong>
        @if (cardInfo.status) {
          - {{ cardInfo.status }}
          @if (showPrimaryAssociation()) {
            @if (primaryAssociation(); as primaryAssociation) {
              with <a [routerLink]="routePrefix() + '/' + primaryAssociation.linkUrl">{{ primaryAssociation.name }}</a>
            }
          }
        }
      </div>
    </span>

    <!-- Activity subtitle -->
    @if (cardInfo.subtitle) {
      <span activity-subtitle>
        {{ cardInfo.subtitle }}
      </span>
    }

    <!-- Always visible content -->
    <div activity-preview>
      <!-- Primary link -->
      @if (cardInfo.analysisProcessedTranscriptID) {
        <div class="link analysis-link">
          <a [href]="externalRoutePrefix() + '/meetings/meeting/' + cardInfo.analysisProcessedTranscriptID"
            >{{ 'ACTIVITY.MEETING.MEETING_ANALYSIS.VIEW_CALL' | translate }} <mat-icon>open_in_new</mat-icon></a
          >
        </div>
      } @else if (cardInfo.activityUrl) {
        <div class="link generic-link">
          <a [href]="cardInfo.activityUrl">{{ cardInfo.activityUrlName || cardInfo.activityUrl }}</a>
        </div>
      } @else if (cardInfo.transcriptJSON) {
        <div class="link view-transcript-link">
          <a data-action="view-transcript-clicked" (click)="openTranscriptModal()">
            {{ 'ACTIVITY.CALL.VIEW_TRANSCRIPT' | translate }}
          </a>
        </div>
      }

      @if (cardInfo.aiSummaryBody) {
        <div class="summarized-by-ai">
          <div class="summary-by-ai">
            <mat-icon class="ai-icon" svgIcon="galaxy-ai-icon" />
            <div>{{ 'ACTIVITY.MEETING.SUMMARY_BY_AI' | translate }}</div>
          </div>
          @if (cardInfo.aiSummaryTitle) {
            <div class="meeting-summary-title">
              <strong><span [innerHTML]="cardInfo.aiSummaryTitle"></span></strong>
            </div>
          }
          <div class="meeting-summary-body">
            <span [innerHTML]="cardInfo.aiSummaryBody"></span>
          </div>
        </div>
      }
      @if (cardInfo.body) {
        <div class="activity-body">
          <crm-activity-rich-text [richText]="cardInfo.body"></crm-activity-rich-text>
        </div>
      }

      <!-- Additional content -->
      <div activity-content>
        <!-- Audio/Video player-->
        <ng-container *ngIf="callRecordingSource$ | async as callUrl">
          <audio class="activity-data-call-recording" preload="metadata" controls src="{{ callUrl }}">
            {{ 'ACTIVITY.AUDIO_PLAYBACK_ERROR' | translate }}
          </audio>
        </ng-container>

        <!-- Call details grid -->
        <crm-activity-data-grid [dataItems]="activityDataItems()" [dateFormat]="dateFormat"></crm-activity-data-grid>
      </div>
    </div>
  </crm-activity-card>
</div>
